module.exports = __webpack_public_path__ + "img/logo-ww.e6882c77.png";